import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseHttpService } from "./base.http.service";
import { Observable } from "rxjs";
import { ContractType } from "../types/contract-types";
import { InstanceRequest, InstanceRequestToApprove } from "src/app/components/instance-requests/instance-requests";

@Injectable({
  providedIn: "root",
})
export class InstanceRequestService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  rejectInstanceRequest(id: number, rejectComment: string): Observable<InstanceRequest> {
    return this.http.put<InstanceRequest>(`${this.apiUrl}/api/InstanceRequests/${id}/reject`, { rejectComment });
  }

  approveInstanceRequest(id: number, approveData: InstanceRequestToApprove): Observable<ContractType> {
    return this.http.put<ContractType>(`${this.apiUrl}/api/InstanceRequests/${id}/approve`, approveData);
  }

  deleteInstanceRequest(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/api/InstanceRequests/${id}`);
  }
}
